import * as actionTypes from '../constants/actionTypes';
export function historyBack(meta) {
    return {
        type: actionTypes.HISTORY_BACK,
        meta: meta,
    };
}
